import { useContext } from 'react';
import PriceFormatContext from 'Index/contexts/price_format_context';

export default () => useContext(PriceFormatContext);
